import { render, staticRenderFns } from "./BrazilSelectField.vue?vue&type=template&id=088f48b4&"
import script from "./BrazilSelectField.vue?vue&type=script&lang=js&"
export * from "./BrazilSelectField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports